import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './StudentSchedule.css';
import { format, parseISO, addWeeks } from 'date-fns';


const StudentSchedule = ({ studentId , studentType}) => {
  const [schedules, setSchedules] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingSchedule, setEditingSchedule] = useState(null);
  const [formData, setFormData] = useState({
    ClassDateTime: '',
    IdTeacher: '',
    TeacherFullName: '',
    done: false,
    TeacherJoin: '',
    StudentJoin: '',
    Issue: false,
    sendEmailCancelTeacher: false,
    sendEmailRescheduleTeacher: false,
    sendEmailCancelParent: false,
    sendEmailRescheduleParent: false
  });
  const [showAddModal, setShowAddModal] = useState(false);
  const [addFormData, setAddFormData] = useState({
    classDateTime1: '',
    classDateTime2: '',
    nbSessions: 8,
    sendEmailNew: false,
    sendEmailUpdate: false,
    teacherId: ''

  });
  const [submitting, setSubmitting] = useState(false); // New state for submit button
  const [adding, setAdding] = useState(false); // New state for submit button

  const fetchData = async () => {
    try {
      setLoading(true);
      
      // Fetch schedules and teachers in parallel
      const [scheduleResponse, teacherResponse, studentResponse] = await Promise.all([
        axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/studentprofile/schedule/${studentId}`,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
        ),
        axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/admin/studentprofile/teachers/list`,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
        )
      ]);

      setSchedules(scheduleResponse.data);
      setTeachers(teacherResponse.data);
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [studentId]);

  const formatForDateTimeInput = (dateString) => {
    if (!dateString) return '';
    try {
      const date = parseISO(dateString);
      return format(date, "yyyy-MM-dd'T'HH:mm");
    } catch {
      return '';
    }
  };
  const handleAddInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setAddFormData({
      ...addFormData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleAddSubmit = async (e) => {
  e.preventDefault();
  setAdding(true);

  // Determine correct endpoint
  const endpoint = studentType
    ? 'addscheduledemo' // demo student
    : 'addschedule';    // paid student

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/admin/studentprofile/${endpoint}/${studentId}`,
      addFormData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('userData')}`,
        },
      }
    );

    setShowAddModal(false);
    setAddFormData({
      classDateTime1: '',
      classDateTime2: '',
      nbSessions: 8,
      sendEmailNew: true,
      sendEmailUpdate: true,
      teacherId: '',
    });

    await fetchData(); // Refresh data
  } catch (err) {
    setError(err.response?.data?.error || err.message);
  } finally {
    setAdding(false);
  }
};





  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleTeacherChange = (e) => {
    const teacherId = e.target.value;
    const selectedTeacher = teachers.find(t => t.id === teacherId);
    setFormData({
      ...formData,
      IdTeacher: teacherId,
      TeacherFullName: selectedTeacher ? selectedTeacher.name : ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true); // Set submitting state to true
    
    try {
      const updatedSchedule = {
        ...formData,
        done: formData.done ? 1 : 0,
        Issue: formData.Issue ? 1 : 0
      };

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/studentprofile/updateschedule/${editingSchedule.Id}/${studentId}`,
        updatedSchedule,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('userData')}` } }
      );

      await fetchData(); // Refresh data after successful update
      setEditingSchedule(null);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setSubmitting(false); // Reset submitting state
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return format(parseISO(dateString), "MMM dd, yyyy hh:mm a");
    } catch {
      return dateString;
    }
  };

  if (loading) return <div className="loading">Loading schedules...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="schedule-container">
      <div className="schedule-header">
        <h2>Student Schedule</h2>
        
      </div>
      
      <div className="schedule-table-container">
        <table className="schedule-table">
          <thead>
            <tr>
              <th>Class Date</th>
              <th>Status</th>
              <th>Teacher Joined</th>
              <th>Student Joined</th>
              <th>Issue</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {schedules.length > 0 ? (
              schedules.map((schedule) => (
                <tr key={schedule.Id}>
                  <td>{formatDateTime(schedule.ClassDateTime)}</td>
                  <td>
                    <span className={`status-badge ${schedule.done === 1 ? 'completed' : 'pending'}`}>
                      {schedule.done === 1 ? 'Completed' : 'Pending'}
                    </span>
                  </td>
                  <td>{formatDateTime(schedule.TeacherJoin)}</td>
                  <td>{formatDateTime(schedule.StudentJoin)}</td>
                  <td>
                    {schedule.Issue === 1 ? (
                      <span className="issue-badge">Yes</span>
                    ) : (
                      <span className="no-issue-badge">No</span>
                    )}
                  </td>
                  <td>
                    
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-schedules">No schedules found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {editingSchedule && (
        <div className="modal-overlay">
          <div className="edit-modal">
            <h3>Edit Schedule</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Teacher:</label>
                <select
                  name="IdTeacher"
                  value={formData.IdTeacher}
                  onChange={handleTeacherChange}
                  className="teacher-select"
                  required
                >
                  <option value="">Select a teacher</option>
                  {teachers.map(teacher => (
                    <option key={teacher.id} value={teacher.id}>
                      {teacher.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Class Date & Time:</label>
                <input
                  type="datetime-local"
                  name="ClassDateTime"
                  value={formData.ClassDateTime}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <div className="form-group checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="done"
                    checked={formData.done}
                    onChange={handleInputChange}
                  /> Class Completed
                  
                </label>
              </div>
              
              <div className="form-group">
                <label>Teacher Joined At:</label>
                <input
                  type="datetime-local"
                  name="TeacherJoin"
                  value={formData.TeacherJoin}
                  onChange={handleInputChange}
                />
                {formData.TeacherJoin && (
                <button
                  type="button"
                  className="clear-btn"
                  onClick={() =>
                    setFormData(prev => ({ ...prev, TeacherJoin: '' }))
                  }
                  title="Clear"
                >
                  × Clear
                </button>
              )}
              </div>
              
              <div className="form-group">
                <label>Student Joined At:</label>
                <input
                  type="datetime-local"
                  name="StudentJoin"
                  value={formData.StudentJoin}
                  onChange={handleInputChange}
                />
                {formData.StudentJoin && (
                <button
                  type="button"
                  className="clear-btn"
                  onClick={() =>
                    setFormData(prev => ({ ...prev, StudentJoin: '' }))
                  }
                  title="Clear"
                >
                  × Clear
                </button>
              )}
              </div>
              
              <div className="form-group checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    name="Issue"
                    checked={formData.Issue}
                    onChange={handleInputChange}
                  /> Had Issue
                  
                </label>
              </div>
              
              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setEditingSchedule(null)}>
                  Cancel
                </button>
                <button type="submit" className="save-btn" disabled={submitting}>
                  {submitting ? 'Submitting...' : 'Save Changes'}
                </button>
              </div>
              <div className="email-options-section">
                <h4>Email Notifications</h4>
                <div className="email-options-grid">
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="sendEmailCancelTeacher"
                        checked={formData.sendEmailCancelTeacher}
                        onChange={handleInputChange}
                      /> Send Cancel Email to Teacher
                    </label>
                  </div>
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="sendEmailRescheduleTeacher"
                        checked={formData.sendEmailRescheduleTeacher}
                        onChange={handleInputChange}
                      /> Send Reschedule Email to Teacher
                    </label>
                  </div>
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="sendEmailCancelParent"
                        checked={formData.sendEmailCancelParent}
                        onChange={handleInputChange}
                      /> Send Cancel Email to Parent
                    </label>
                  </div>
                  <div className="form-group checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="sendEmailRescheduleParent"
                        checked={formData.sendEmailRescheduleParent}
                        onChange={handleInputChange}
                      /> Send Reschedule Email to Parent
                    </label>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
     
{showAddModal && (
  !studentType ? (
    <div className="modal-overlay">
      <div className="add-modal">
        <h3>Add Paid New Schedule</h3>
        <form onSubmit={handleAddSubmit}>
          <div className="form-group">
            <label>Teacher:</label>
            <select
              name="teacherId"
              value={addFormData.teacherId}
              onChange={handleAddInputChange}
              className="teacher-select"
              required
            >
              <option value="">Select a teacher</option>
              {teachers.map(teacher => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>First Class Date & Time:</label>
            <input
              type="datetime-local"
              name="classDateTime1"
              value={addFormData.classDateTime1}
              onChange={handleAddInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Second Class Date & Time:</label>
            <input
              type="datetime-local"
              name="classDateTime2"
              value={addFormData.classDateTime2}
              onChange={handleAddInputChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Number of Sessions (total):</label>
            <input
              type="number"
              name="nbSessions"
              value={addFormData.nbSessions}
              onChange={handleAddInputChange}
              min="2"
              max="52"
              required
              className="session-input"
            />
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="sendEmailNew"
                checked={addFormData.sendEmailNew}
                onChange={handleAddInputChange}
              /> Send email for new schedule
            </label>
          </div>

          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="sendEmailUpdate"
                checked={addFormData.sendEmailUpdate}
                onChange={handleAddInputChange}
              /> Send email for schedule updates
            </label>
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-btn" 
              onClick={() => setShowAddModal(false)}
            >
              Cancel
            </button>
            <button type="submit" className="save-btn" disabled={adding}>
              {adding ? 'adding...' : 'Create Schedule'}
            </button>
          </div>
        </form>
      </div>
    </div>
  ) : (
    <div className="modal-overlay">
      <div className="add-modal">
        <h3>Add Demo New Schedule</h3>
        <form onSubmit={handleAddSubmit}>
          <div className="form-group">
            <label>Teacher:</label>
            <select
              name="teacherId"
              value={addFormData.teacherId}
              onChange={handleAddInputChange}
              className="teacher-select"
              required
            >
              <option value="">Select a teacher</option>
              {teachers.map(teacher => (
                <option key={teacher.id} value={teacher.id}>
                  {teacher.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Class Date & Time:</label>
            <input
              type="datetime-local"
              name="classDateTime1"
              value={addFormData.classDateTime1}
              onChange={handleAddInputChange}
              required
            />
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              className="cancel-btn" 
              onClick={() => setShowAddModal(false)}
            >
              Cancel
            </button>
            <button type="submit" className="save-btn" disabled={adding}>
              {adding ? 'adding...' : 'Create Schedule'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
)}




    </div>
  );
};

export default StudentSchedule;